import React, { useEffect, useRef } from 'react';
import { classNames } from 'primereact/utils';
import { InputText } from 'primereact/inputtext';
import AppMenu from './AppMenu';
import { useNavigate } from 'react-router-dom';
import image from "./assets/images/Camaleão.png"
import { getToken, logout } from './service/localStorage/localStorage';
import { Tooltip } from 'primereact/tooltip';
import { useFetchUser } from './service/requests/services';
import AwsImage from './components/AwsImage';

const AppTopbar = (props) => {
    const navigate = useNavigate();
    const searchPanelDesktop = useRef(null);
    const searchPanelMobile = useRef(null);
    const { data: user } = useFetchUser()

    useEffect(() => {
        if (props.searchActive) {
            if (window.innerWidth >= 576) searchPanelDesktop.current.focus();
            else searchPanelMobile.current.focus();
        }
    }, [props.searchActive]);

    const onInputKeydown = (event) => {
        const key = event.which;

        //escape, tab and enter
        if (key === 27 || key === 9 || key === 13) {
            if (props.searchActive) props.onTopbarSearchToggle();
        }
    };

    return (
        <div className="layout-topbar">
            <div className="layout-topbar-wrapper">
                <div className="layout-topbar-left">
                    <button tabIndex="0" className="menu-button p-link" onClick={props.onMenuButtonClick}>
                        <i className="pi pi-bars"></i>
                    </button>
                    <button tabIndex="0" id="logo-link" onClick={() => navigate('/')} className="layout-topbar-logo p-link">
                        <img src={image} alt="freya-layout" />
                    </button>
                </div>
                <AppMenu
                    menuMode={props.menuMode}
                    sidebarActive={props.sidebarActive}
                    sidebarStatic={props.sidebarStatic}
                    model={props.menu}
                    menuActive={props.menuActive}
                    onRootMenuItemClick={props.onRootMenuItemClick}
                    onMobileMenuActive={props.onMobileMenuActive}
                    onMenuItemClick={props.onMenuItemClick}
                    onSidebarMouseOver={props.onSidebarMouseOver}
                    onSidebarMouseLeave={props.onSidebarMouseLeave}
                    onToggleMenu={props.onToggleMenu}
                    resetActiveIndex={props.resetActiveIndex}
                    onMenuClick={props.onMenuClick}
                />

                <div className="layout-topbar-right">
                    <ul className="layout-topbar-actions">
                        <li className={classNames('topbar-item search-item', { 'active-topmenuitem': props.searchActive })}>
                            {/* <button className="p-link" tabIndex="0" style={{ cursor: 'pointer' }} onClick={props.onTopbarSearchToggle}>
                                <i className="topbar-icon pi pi-search"></i>
                            </button>

                            <div className="search-input-wrapper" onClick={props.onTopbarSearchClick}>
                                <span className="p-input-icon-left">
                                    <i className="pi pi-search"></i>
                                    <InputText ref={searchPanelDesktop} type="text" placeholder="Search..." onKeyDown={onInputKeydown} />
                                </span>
                            </div> */}

                            <ul className="fadeInDown">
                                <div className="search-input-wrapper p-fluid" style={{ width: '100%' }} onClick={props.onTopbarSearchClick}>
                                    <span className="p-input-icon-left">
                                        <i className="pi pi-search"></i>
                                        <InputText ref={searchPanelMobile} type="text" placeholder="Search..." onKeyDown={onInputKeydown} />
                                    </span>
                                </div>
                            </ul>
                        </li>
                        <Tooltip target=".goludz" mouseTrack mouseTrackLeft={10} />
                        <button data-pr-position="left" data-pr-tooltip="Ir para Ludz.one" tabIndex="0" style={{ cursor: 'pointer' }} className="layout-rightpanel-button p-link goludz" onClick={() => window.location.href = "https://ludz.one/pass/" + getToken()}>
                            <i className=" custom-target-icon pi pi-arrow-up-right" data-pr-tooltip="Ir para Ludzone" data-pr-position="bottom"
                            ></i>
                        </button>
                        <li className={classNames('topbar-item user-profile', { 'active-topmenuitem fadeInDown': props.topbarUserMenuActive })}>

                            <button data-pr-position="left" data-pr-tooltip={user?.username} className="p-link" style={{ cursor: 'pointer' }} onClick={props.onTopbarUserMenuClick}>
                                <AwsImage
                                    awsId={user?.aws_fk ?? user?.aws?.id}
                                    aws={user?.aws}
                                    alt="freya-layout"
                                    usage="avatar"
                                    width={36}
                                    height={36}
                                />
                            </button>
                            <ul className="fadeInDown">
                                <div style={{ display: 'flex', alignItems: "center", padding: '16px', wordBreak: 'break-all' }}>
                                    <AwsImage
                                        style={{ width: "28px", height: "28px", borderRadius: "10px", marginTop: "2spx", objectFit: "cover" }}
                                        awsId={user?.aws_fk ?? user?.aws?.id}
                                        aws={user?.aws}
                                        alt="freya-layout"
                                        usage="avatar"
                                        width={28}
                                        height={28}
                                    />
                                    <div className="flex flex-column" style={{ marginLeft: "8px" }} >
                                        <span style={{ wordBreak: 'break-word' }} className="font-bold">{user?.username}</span>
                                        <span style={{ wordBreak: 'break-word' }} className="text-sm">{user?.email}</span>
                                    </div>
                                </div>
                                <li onClick={() => { logout(); window.location.reload() }}>
                                    <button className="p-link" >
                                        <span>Sair</span>
                                    </button>
                                </li>

                            </ul>
                        </li>
                    </ul>


                </div>
            </div>
        </div>
    );
};

export default AppTopbar;
